import React from "react";
import { makeStyles } from "@mui/styles";
import { Input } from "@mui/material";

const useStyles = makeStyles({
  root: {
    padding: "20px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    overflow: "hidden",
  },
  searchInput: {
    width: "250px",
    padding: "5px 10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    borderRadius: "10px", // 🌟 Rounded corners for table
    overflow: "hidden",
    border: "1px solid #ddd", // optional outer border
  },
  th: {
    backgroundColor: "#000",
    color: "#fff",
    padding: "10px",
    textAlign: "left",
  },
  td: {
    padding: "10px",
    borderBottom: "1px solid #ddd",
    color: "#000",
  },
  firstRowTd: {
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
  },
  lastRowTd: {
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    borderBottom: "none",
  },
  '@media (max-width: 500px)': {
    root: {
      padding: "10px",
    },
    th: {
      fontSize: "12px",
    },
    td: {
      fontSize: "12px",
    },
  },
});

export default function Layout({ userTableData, isLoading, searchQuery, setSearchQuery }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {/* Search */}
      <Input
        className={classes.searchInput}
        placeholder="Search by name, email, phone..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {/* Table */}
      {isLoading ? (
        <p>Loading users...</p>
      ) : (
        <div className={classes.tableWrapper}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th className={classes.th}>Name</th>
                <th className={classes.th}>Phone Number</th>
                <th className={classes.th}>Email</th>
                <th className={classes.th}>Wallet Amount</th>
              </tr>
            </thead>
            <tbody>
              {userTableData.length === 0 ? (
                <tr>
                  <td colSpan={5} className={classes.td}>
                    No users found
                  </td>
                </tr>
              ) : (
                userTableData.map((user, idx) => (
                  <tr key={user.id}>
                    <td className={`${classes.td} ${idx === 0 ? classes.firstRowTd : ""}`}>{user.userName}</td>
                    <td className={classes.td}>{user.phoneNumber}</td>
                    <td className={classes.td}>{user.email}</td>
                    <td className={classes.td}>{user.walletAmount}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
